import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../utils/OggettiUtili";
import TabelleMonitoraggio from "./TabelleMonitoraggio";
import {states} from '../Wizard/States/States';
import Utils from "../../utils/Utils"
import SessioneUtente from "../../sessionManager/SessioneUtente";
import Ruoli from "../../utils/Ruoli.json";

class SorveglianzaTBCPolmonare extends Component {

    state = {
        filtri: {
            ulssSegnalazione: SessioneUtente.getInstance().ruoliUtente.includes(Ruoli.Operatore_Sisp.descrizione)
            || SessioneUtente.getInstance().ruoliUtente.includes(Ruoli.Operatore_Sisp_HIV.descrizione) ? OggettiUtili.ulssMap[SessioneUtente.getInstance().ulss] : "",
            statoSegnalazione: "",
            gruppoStatoSegnalazione: "",
            esitoTrattamento: "",
            dataDa: "",
            dataA: ""
        },
        ulss: OggettiUtili.ulssMap
    }


    rowsFiltriSorveglianza = [
        {
            gruppoStatoSegnalazione: {
                id: "gruppoStatoSegnalazione", text: "", tipo: "select", field: "gruppoStatoSegnalazione", numeroCol: 2,
                suggestions: OggettiUtili.statoSchedaStandard, defaultSelect: "--Scheda Standard--"
            },
            dataDa: {
                id: "dataDa",
                text: "dataDa",
                tipo: "data",
                field: "dataDa",
                placeholder: "data segnalazione da",
                numeroCol: 3
            }
        },
        {
            ulssSegnalazione: {
                id: "ulssSegnalazione",
                text: (SessioneUtente.getInstance().ruoliUtente.includes(Ruoli.Operatore_Sisp.descrizione)
                    || SessioneUtente.getInstance().ruoliUtente.includes(Ruoli.Operatore_Sisp_HIV.descrizione)) ? OggettiUtili.ulssMap[SessioneUtente.getInstance().ulss].descrizione : "ulss segnalazione",
                tipo: "autocomplete",
                field: "ulssSegnalazione",
                numeroCol: 1,
                suggestions: this.state.ulss,
                keyField: "codice",
                descriptionField: "descrizione",
                suggestionField: "descrizione",
                disabled: !!(SessioneUtente.getInstance().ruoliUtente.includes(Ruoli.Operatore_Sisp.descrizione)
                    || SessioneUtente.getInstance().ruoliUtente.includes(Ruoli.Operatore_Sisp_HIV.descrizione))
            },
            esitoTrattamento: {
                id: "esitoTrattamento", text: "", tipo: "select", field: "esitoTrattamento", numeroCol: 2,
                suggestions: Utils.sortObjectOfObject(OggettiUtili.EsitoTBCTrattamento, "descrizione"), defaultSelect: "--Esito trattamento--"
            },
            dataA: {
                id: "dataA",
                text: "dataA",
                tipo: "data",
                field: "dataA",
                placeholder: "data segnalazione a",
                numeroCol: 3
            }
        }

    ]

    colsTabSorveglianza = [
        {
            key: "idSegnalazione",
            name: "ID Segnalazione",
            sortDirection: "none",
            tipo: "link",
            path: "/wizardSegnalazione",
            nomeParametro: "idSegnalazione",
            state: {currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI}
        },
        {
            key: "ulssSegnalazione",
            name: "Tables.Home.ulssSegn",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.ulssMap,
            campo: "descrizione"
        },
        {key: "utenteInserimento", name: "Utente Inserimento", sortDirection: "none"},
        {key: "dataSegnalazione", name: "Data segnalazione", sortDirection: "none", tipo: "data"},
        {
            key: "statoSegnalazione",
            name: "Stato segnalazione",
            sortDirection: "none",
            tipo: "pallino",
            oggetto: OggettiUtili.statoSegnalazione
        },
        {
            key: "esitoTrattamento",
            name: "Esito trattamento",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.EsitoTBCTrattamento,
            campo: "descrizione"
        },
    ]

    sendFiltri(filtriInvio) {
        this.props.creaFiltri({filtri: filtriInvio})
    }

    setStateGenerico(object) {
        this.setState(object)
    }

    constructor(props) {
        super(props);
        this.setStateGenerico = this.setStateGenerico.bind(this)
        this.sendFiltri = this.sendFiltri.bind(this)
    }


    render() {
        const {t} = this.props;

        return (
            <div>
                <TabelleMonitoraggio
                    cols={this.colsTabSorveglianza}
                    title={t("monitoraggio.titoloTable")}
                    emptyMsg={"Non ci sono segnalazioni"}
                    lengthEditable={true}
                    homePage={true}
                    information={["01", "07", "00", "05"]}
                    rowFiltri={this.rowsFiltriSorveglianza}
                    filtri={this.state.filtri}
                    sendFiltri={this.sendFiltri}
                    ruolo={"r"}
                    tbcpolmonare={"1"}
                    setStateGenerico={this.setStateGenerico}
                />
            </div>
        )
    }


}

export default withTranslation('common')(SorveglianzaTBCPolmonare);

